/** @jsxImportSource theme-ui */
import React from 'react';

import { TimeFrameEnumType } from 'models/TimeframeModels';
import { formatDateUntilToday, getMomentAgo } from 'utils/dateTimeHelpers';

import { Typography } from 'components/_common/Typography';

type TimeframeItemProps = {
  timeframeType: TimeFrameEnumType;
  customDate?: Date;
  value: string | number | boolean;
  label: string;
};

export const TimeframeItem: React.FC<TimeframeItemProps> = ({
  value,
  timeframeType,
  customDate,
  label,
}) => {
  return (
    <div sx={{ minHeight: '20px' }}>
      <Typography
        sx={{ position: 'relative' }}
        inline
        variant={value === timeframeType ? 'subtitle2' : 'body2'}
        color={value === timeframeType ? 'sea100' : 'stone70'}
      >
        {value === timeframeType && <span className="active-item-dot-marker" />} {label}
        {timeframeType === 'custom' && customDate && ': '}
      </Typography>
      <Typography
        inline
        variant={value === timeframeType ? 'subtitle2' : 'body2'}
        color={value === timeframeType ? 'stone90' : 'stone70'}
      >
        {timeframeType === '30days'
          ? formatDateUntilToday(getMomentAgo('last-30-days').toDate())
          : timeframeType === '60days'
          ? formatDateUntilToday(getMomentAgo('last-60-days').toDate())
          : timeframeType === '1year'
          ? formatDateUntilToday(getMomentAgo('last-year').toDate())
          : timeframeType === 'custom' && !!customDate
          ? formatDateUntilToday(customDate)
          : ''}
      </Typography>
    </div>
  );
};
